import React, { useState } from 'react';
import WorkflowListShell from '../components/workflow/WorkflowListShell';
import WorkflowStatusBadge from '../components/workflow/WorkflowStatusBadge';
import useWorkflowPerms from '../components/workflow/useWorkflowPerms';
import NowName from '../components/shared/NowName';

// Screening — list page (docs/modules/workflow-screening.md).
// QM's background check as its own flow. Three origins share the list:
// requests an approved Engagement Registration or Engagement Amendment opened
// (QM completes; nothing to return) and requests filed directly (QM may return
// them for changes).
const filterSelectCls = 'px-3 py-2 border border-slate-300 rounded-lg text-sm bg-white focus:ring-2 focus:ring-blue-500 focus:border-blue-500';

export const ScreeningOriginBadge = ({ request }) => (
  request.source !== 'standalone' ? (
    <span className="inline-flex items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium bg-indigo-50 text-indigo-700">
      From {request.sourceRequestNo || (request.source === 'ear' ? 'amendment' : 'registration')}
    </span>
  ) : (
    <span className="inline-flex items-center whitespace-nowrap rounded px-2 py-0.5 text-xs font-medium bg-slate-100 text-slate-600">
      Standalone
    </span>
  )
);

const WorkflowScreening = () => {
  const { canSubmit } = useWorkflowPerms('screening');
  const [source, setSource] = useState('');
  return (
    <WorkflowListShell
      title="Screening"
      subtitle="QM background checks."
      newTo="/workflow/screening/new"
      canCreate={canSubmit}
      apiPath="/api/workflow/screening"
      rowTo={(r) => `/workflow/screening/${r.id}`}
      searchPlaceholder="Search request no, client, company, UEN or requester…"
      defaultSort={{ key: 'createdAt', direction: 'desc' }}
      extraParams={{ source }}
      filters={(
        <select value={source} onChange={(e) => setSource(e.target.value)} className={filterSelectCls} aria-label="Origin">
          <option value="">All origins</option>
          <option value="engreg">From Engagement Registration</option>
          <option value="ear">From Engagement Amendment</option>
          <option value="standalone">Filed directly</option>
        </select>
      )}
      columns={[
        { key: 'requestNo', label: 'Request', sortKey: 'requestNo', render: (r) => <span className="font-medium text-blue-700">{r.requestNo}</span> },
        { key: 'clientGroup', label: 'Client Group', sortKey: 'clientGroup', render: (r) => <NowName value={r.clientGroup} now={r.clientGroupNow} /> },
        { key: 'entities', label: 'Companies', render: (r) => <NowName value={r.entityNames} now={r.entityNamesNow} className="text-slate-600" />, cellTitle: (r) => r.entityNames || '' },
        { key: 'source', label: 'Origin', sortKey: 'source', render: (r) => <ScreeningOriginBadge request={r} /> },
        { key: 'status', label: 'Status', sortKey: 'status', render: (r) => <WorkflowStatusBadge status={r.status} /> },
        { key: 'requester', label: 'Requested By', render: (r) => <span className="text-slate-500">{r.requesterEmail}</span> },
      ]}
    />
  );
};

export default WorkflowScreening;
